module.exports = __webpack_public_path__ + "video/SAF-1000-2_Ares_BEC_2025.69e23f55.vtt";